var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("birth-date"),
        state: _vm.getState(_vm.$v.recipient.birth_date),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.birth_date),
        required: "",
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          placeholder: "DD/MM/AAAA",
          name: "birth_date",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: _vm.updateField },
        model: {
          value: _vm.birth_date,
          callback: function ($$v) {
            _vm.birth_date = $$v
          },
          expression: "birth_date",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }